import React from "react";
import styled from "styled-components";
import { Grid, Row, Col } from "react-flexbox-grid";
import constant from "../../Template/Template9Pages/constant";
import { Link } from "react-router-dom";
import media from "../media";

const BreadCrumb = styled.div`
  background: ${(prop) => prop.bgColor || "#fffafa"};

  padding: 10px 0;
  
  a {
    margin: 2px;
    font-size: 14px;
    text-decoration: none;
    color: ${constant.greyColor};
    &:hover{
      color:${constant.secondaryColor}
    }
  }
  span {
    color: ${constant.secondaryColor};
    padding: 0 5px;
  }
  p{
    color: ${constant.secondaryColor};
  }
  /* .homeLink{
    font-size: 16px;
    font-weight: 700;
    text-decoration: none;
    position: relative;
    margin-left:34px ;
    margin-right:5px ;
    color: ${constant.secondaryColor};
    &:hover{
      color:${constant.bgBlack}
    }
    &::before{
      content:'←';
      position: absolute;
      height: 100%;
      width: 100%;
      bottom: 50%;
      left: -75%;
      font-size: 28px;
    }
  } */
`;

const BreadCrumbComponent2 = ({
  previousUrl,
  previousName,
  currentUrl,
  bgColor,
}) => {
  return (
    <BreadCrumb  bgColor={bgColor}>
      <Link  to="/">Home</Link> <span>/</span>
      {previousUrl && (
        <>
          <Link to={previousUrl}>{previousName}</Link>
          <span> / </span>
        </>
      )}
      <span>{currentUrl}</span>
    </BreadCrumb>
  );
};

export default BreadCrumbComponent2;
